export const ChevronDownIcon = (props) => {
  return (
    <svg
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M15.7585 1.26798L8.52697 7.81321C8.24857 8.0618 7.83109 8.0618 7.55246 7.81321L0.240435 1.26798C-0.057737 0.958903 -0.0818271 0.540735 0.186346 0.240746C0.47179 -0.0728798 0.931775 -0.0683344 1.21495 0.186202L7.99972 6.29508L14.7858 0.186202C15.0856 -0.0809248 15.5445 -0.0574716 15.814 0.2402C16.0813 0.540735 16.0585 0.958903 15.7585 1.26798Z"
        fill="#525B7A"
      />
    </svg>
  );
};
